import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FileDownloadOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"file_download_off"}/>
}
